let updateBlockStyles = () => {
  let items = document.querySelectorAll(`.ndow-hero`);
  
  if ( items.length > 0 ) {
    items.forEach(el => {
      let align = el.getAttribute('content-align');
      let content = el.querySelector('.ndow-hero__content');

      content.style.setProperty('--content-align', align);
    });

    return;
  } else {
    setTimeout(updateBlockStyles, 100);
  }
}

updateBlockStyles();